<template>
  <div class="transactionsForm">
    <el-table
        :data="formList"
        border
        stripe
        class="historyTable"
        style="width: 100%">
        <el-table-column
          prop="pay_source"
          :label="pc_lang.Classification"
          class-name="pay_source"
          align="center"
          width="120">
          <template slot-scope="scope">
            <img :src="scope.row.pay_source_img || require('@/assets/image/mall.png')" alt="">
          </template>
        </el-table-column>
        <el-table-column
          prop="creation_time"
          :label="pc_lang.Date"
          align="center"
          width="94">
        </el-table-column>
        <el-table-column
          prop="trade_notes"
          :label="pc_lang.Remark + ' | ' + pc_lang.Transaction_number"
          class-name="trade_notes"
          align="center">
          <template slot-scope="scope">
            <p v-text="scope.row.trade_notes"></p>
            <div v-text="scope.row.trade_serial_no"></div>
          </template>
        </el-table-column>
        <el-table-column
          prop="actual_amount"
          :label="pc_lang.Amount"
          align="center"
          class-name="actual_amount"
          width="120">
          <template slot-scope="scope">
            <span v-text="scope.row.trade_status == 1 ? scope.row.amount : scope.row.actual_amount" class="minus" v-if="parseFloat(scope.row.actual_amount) < 0 || parseFloat(scope.row.amount) < 0"></span>
            <span v-text="scope.row.trade_status == 1 ? scope.row.amount : scope.row.actual_amount" class="plus" v-else></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="actual_currency_short"
          :label="pc_lang.Currency"
          align="center"
          width="100">
          <template slot-scope="scope">
            <span v-text="scope.row.currency_short" v-if="scope.row.trade_status == 1"></span>
            <span v-text="scope.row.actual_currency_short" v-else></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="pay_type"
          :label="pc_lang.Payment_method"
          align="center"
          width="120">
          <template slot-scope="scope">
            {{ getDealWayWords(scope.row.pay_type) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="trade_type"
          :label="pc_lang.Transaction_Type"
          align="center"
          width="120">
          <template slot-scope="scope">
            {{ getDealTypeWords(scope.row.trade_type) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="trade_status"
          :label="pc_lang.Status"
          align="center"
          width="120">
          <template slot-scope="scope">
            {{ getDealStatusWords(scope.row.trade_status) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="pc_lang.Operate"
          align="center"
          width="120">
          <template slot-scope="scope">
<!--            <p v-if="scope.row.trade_status == 1"><el-button @click="$router.push({ path: `/pay?tradeSerialNo=${scope.row.trade_serial_no}` })" type="text" size="small" class="paycolor">{{ pc_lang['Pay'] }}</el-button></p>-->
            <p><el-button @click="handleClick(scope.row)" type="text" size="small" class="maincolor">{{pc_lang.View}}</el-button></p>
          </template>
        </el-table-column>
      </el-table>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'TransactionsForm',
  props: {
    formList: {
      type: Array,
      default: ()=> new Array
    }
  },
  components: {

  },
  computed: {

  },
  async mounted() {

  },
  methods: {
    /* 查看详情 */
    handleClick(item) {
      this.$router.push({path: '/tradeDetails?trade_serial_no=' + item.trade_serial_no})
    },
    /* 支付状态文字 */
    getDealWayWords(type) {
      let words = this.dealWay.filter(obj=> {
        return obj.id === type
      })[0]
      return !!words ? words.words : '-'
    },
    /* 交易状态文字 */
    getDealTypeWords(type) {
      let words = this.dealType.filter(obj=> {
        return obj.id === type
      })[0]
      return !!words ? words.words : '-'
    },
    /* 交易类型文字 */
    getDealStatusWords(type) {
      let words = this.dealStatus.filter(obj=> {
        return obj.id === type
      })[0]
      return !!words ? words.words : '-'
    }
  }
}
</script>
<style lang="scss" scoped>

.historyTable{
  .pay_source{
    img{
      width: 30px;
    }
  }
  .trade_notes{
    p{
    }
    div{
      color: #bbb;
    }
  }
  .actual_amount{
    .minus{
      color: #FF7B0E;
    }
    .plus{
      color: #1BB974;
    }
  }
  ::v-deep.cell{
    word-break: break-word;
  }
}
.paycolor{
  color: #ff7b0e;
}
.maincolor{
  color: $blue;
}
::v-deep.el-table th>.cell{
  word-break: keep-all;
}
</style>